import React from 'react';
import PropTypes from 'prop-types';
import root from 'window-or-global';
import SizePosition from './SizePosition';
import throttle from 'lodash.throttle';

export default class ParallaxElement extends SizePosition {
    static propTypes = {
        children: PropTypes.node,
        yStrength: PropTypes.number,
        xStrength: PropTypes.number,
        id: PropTypes.string,
        xAnimateFromLeft: PropTypes.bool,
        xAnimateFromRight: PropTypes.bool,
        stopX: PropTypes.number,
        stopY: PropTypes.number,
        exitLeft: PropTypes.bool
    };

    state = {
        yPos: 0,
        elPosX: 0,
        elPosY: 0,
        opacity: 0
    };
    componentDidMount() {
        root.addEventListener('scroll', this.throttleMouse);
        const el = this.element;
        const yPos = root.scrollY;
        this.setInitialDistance(el, yPos);
    }

    componentWillUnmount() {
        root.removeEventListener('scroll', this.throttleMouse);
    }

    setInitialDistance = (el, yPos) => {
        const elPosition = el.getBoundingClientRect();
        const elTop = elPosition.top;
        const elPosY = yPos > 0 ? (elTop + yPos) : elTop;
        let elPosX = 0;
        //xAnimateFromLeft or xAnimateFromRight
        if (this.props.xAnimateFromLeft) {
            elPosX = yPos > 0 ? -(elTop + yPos) / 1.5 : -elTop / 1.5; //where did 1.5 come from?
        } else if (this.props.xAnimateFromRight) {
            elPosX = yPos > 0 ? (elTop + yPos) / 1.5 : elTop / 1.5; //where did 1.5 come from?
        }
        this.setState({
            yPos, elPosY, elPosX, opacity: 1
        });
    };

    throttleMouse = throttle((e) => {
        this.handleScroll(e);
    }, 15, {leading: false});

    handleScroll = (event) => {
        if (!event) return;
        const yPos = root.scrollY;
        this.setState({yPos});
    };

    render() {
        const {
            yStrength, xStrength, id, xAnimateFromLeft, xAnimateFromRight, stopX, stopY, exitLeft
        } = this.props;
        //controls Y positioning
        let mY = (this.state.elPosY - this.state.yPos) * yStrength;
        if (stopY && (this.state.elPosY - this.state.yPos) <= stopY) {
            mY = stopY;
        }
        //controls X positioning
        let mX = 0;
        if (xAnimateFromLeft) {
            mX = (this.state.elPosX + this.state.yPos) * xStrength;
            if (stopX && (this.state.elPosX + this.state.yPos) > stopX) {
                mX = stopX;
            }
        } else if (xAnimateFromRight) {
            mX = (this.state.elPosX - this.state.yPos) * xStrength;
            if (stopX && (this.state.elPosX - this.state.yPos) < stopX) {
                mX = stopX;
            }
        } else if (exitLeft) {
            mX = (this.state.elPosX - this.state.yPos) * xStrength;
        }

        const elPosX = Math.round(mX * 100) / 100;
        const elPosY = Math.round(mY * 100) / 100;

        const elementStyle = {
            position: 'absolute', //to keep children in place
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            transform: `translate3d(${elPosX}px,${elPosY}px,0)`,
            MsTransform: `translate3d(${elPosX}px,${elPosY}px,0)`,
            WebkitTransform: `translate3d(${elPosX}px,${elPosY}px,0)`,
            opacity: this.state.opacity
        };

        const children = React.Children.map(this.props.children, child => React.cloneElement(child));
        return (
            <div
                ref={(c) => {this.setElement(c);}} key={id} id={id} className="parallaxElement"
                style={elementStyle}>
                {children}
            </div>
        );
    }
}

